import Context from 'managers/Context';

import { COMPANIES } from 'constants/Entities';
import { getCrudDataFromBackendForm } from 'utils/copilotRegistry/crudForm';

export const buildPreviewRequest = ({
    category,
    maxResults,
    radiusKm,
    origin,
    includeDuplicates,
}) => ({
    lat: String(origin.lat),
    lng: String(origin.lng),
    radiusMeters: String(Math.round(Number(radiusKm) * 1000)),
    maxResults: String(maxResults),
    query: category || '',
    includePotentialDuplicates: Boolean(includeDuplicates),
});

export const splitByBucket = (leads = []) => ({
    new: leads.filter((lead) => !lead.potential_duplicate),
    duplicates: leads.filter((lead) => lead.potential_duplicate),
});

export const getSelectedLeads = (leads = [], selectedIds = []) => {
    const ids = new Set(selectedIds);
    return leads.filter((lead) => ids.has(lead.id));
};

const findCountry = (countries = [], country) => {
    if (!country) return null;
    const normalized = String(country).toLowerCase();
    return countries.find((item) => {
        const label = String(item?.label || '').toLowerCase();
        const value = String(item?.value || '').toLowerCase();
        return label === normalized || value === normalized;
    });
};

const backendText = (value) => (value == null ? '' : String(value));

const resolveCountryForRow = (data, countries) => {
    const raw = data.idCountryRaw;
    if (raw != null && raw !== '') {
        const idValue = typeof raw === 'object' && raw?.value != null ? raw.value : raw;
        const byId = countries.find((c) => String(c.value) === String(idValue));
        if (byId) return byId;
    }
    return findCountry(countries, data.country);
};

export const toAccountCrudData = (row) => getCrudDataFromBackendForm(COMPANIES.trueName, row?.form);

export const toAccountServerData = (row, countries = []) => {
    const data = row?.data || {};
    const country = resolveCountryForRow(data, countries);
    const comments = backendText(data.comment);
    const warningText = backendText(data.warningText);

    const address1 = data.address1 || data.street || '';

    return {
        nombre: data.name || '',
        tel: data.phone || '',
        email: data.email1 || data.email || '',
        web: data.web || data.website || '',
        nif: data.nif || data.vatNumber || '',
        direccion: address1,
        direccion2: data.address2 || '',
        strPoblacion: data.city || '',
        strProvincia: data.province || '',
        cp: data.postal || '',
        Observaciones: comments,
        warningText,
        idCountry: country?.value || '',
        lat: data.lat || '',
        lon: data.lng || '',
    };
};

export const createCompany = (row) =>
    Context.entityCrudManager
        .init({
            entity: COMPANIES,
            data: toAccountCrudData(row),
            isModal: true,
        })
        .then(({ schema, configMap, dynamicHiddenMap, data }) =>
            Context.entityCrudManager.save({
                entity: COMPANIES,
                customState: {
                    configMap,
                    data,
                    dynamicHiddenMap,
                    ignoreErrors: false,
                    isModal: true,
                    originalData: {},
                    schema,
                },
            }),
        );

export const createCompaniesSequentially = ({
    getError = () => undefined,
    onProgress = () => {},
    rows = [],
}) => {
    const creationDate = new Date().toLocaleDateString();

    return rows.reduce(
        (promise, row) =>
            promise.then((results) =>
                createCompany(row)
                    .then(() => [...results, { ...row, status: 'created', creationDate }])
                    .catch(() => [
                        ...results,
                        {
                            ...row,
                            status: 'pending',
                            error: getError(),
                        },
                    ])
                    .finally(() => {
                        onProgress();
                    }),
            ),
        Promise.resolve([]),
    );
};
